var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import { Text } from "../../elements/Text";
import { StyledRecaptcha, StyledRecaptchaText } from "./styles";
function getWindowDimensions() {
    var width = window.innerWidth, height = window.innerHeight;
    return {
        width: width,
        height: height,
    };
}
export default function Recaptcha(_a) {
    var _b;
    var numberOfAttempts = _a.numberOfAttempts;
    var siteKey_v2 = process.env.MIX_PUBLIC_APP_RECAPTCHA_SITEKEY_V2;
    var _c = __read(useState(false), 2), recaptchaLoaded = _c[0], setRecaptchaLoaded = _c[1];
    var windowDimensions = useRef(getWindowDimensions());
    var renderId = useRef();
    var loadPromise = useRef();
    var numberOfAttemptsToShow = numberOfAttempts >
        ((_b = process.env.MIX_PUBLIC_RECAPTCHA_ATTEMPTS_BEFORE_CHANGE_TO_V2) !== null && _b !== void 0 ? _b : 3);
    var width = windowDimensions.current.width;
    var useMobileRecaptcha = width > 375 ? "normal" : "compact";
    if (loadPromise.current)
        loadPromise.current.then(function () {
            setRecaptchaLoaded(true);
        });
    var renderRecaptcha = useCallback(function () {
        renderId.current = grecaptcha.render("recaptchav2", {
            sitekey: siteKey_v2,
            size: useMobileRecaptcha,
        });
    }, [recaptchaLoaded, numberOfAttemptsToShow, siteKey_v2, useMobileRecaptcha]);
    useEffect(function () {
        if (typeof renderId.current !== 'undefined' && recaptchaLoaded) {
            window.grecaptcha.reset(renderId.current);
        }
    }, [numberOfAttempts]);
    useEffect(function () {
        if (!recaptchaLoaded) {
            loadPromise.current = new Promise(function (resolve) {
                if (window === null || window === void 0 ? void 0 : window.grecaptcha)
                    grecaptcha.ready(resolve);
            });
        }
    }, [numberOfAttemptsToShow]);
    if (recaptchaLoaded &&
        numberOfAttemptsToShow &&
        typeof renderId.current === "undefined") {
        renderRecaptcha();
    }
    return (_jsxs(_Fragment, { children: [!numberOfAttemptsToShow && (_jsx(StyledRecaptchaText, { children: _jsxs(Text, __assign({ textStyle: "body1", color: "fakeBlack" }, { children: ["Este site \u00E9 protegido por reCAPTCHA e as", " ", _jsx(Text, __assign({ renderAs: "a", textStyle: "body1link", color: "tangerine", href: "https://policies.google.com/privacy", target: "_blank", rel: "noreferrer noopener" }, { children: "Pol\u00EDticas de Privacidade" })), " e ", _jsx(Text, __assign({ renderAs: "a", textStyle: "body1link", color: "tangerine", href: "https://policies.google.com/terms", target: "_blank", rel: "noreferrer noopener" }, { children: "Termos de Servi\u00E7o" })), " do ", " Google se aplicam."] })) })), _jsx(StyledRecaptcha, { id: "recaptchav2", "$hidden": Boolean(!numberOfAttemptsToShow) })] }));
}
